import React, { PropTypes } from 'react'
import Modal from 'react-modal'

const baseConstraints = {
  'width': '706px',
  'minWidth': '706px'
}

const BaseModal = ({
  onClose,
  children,
  title,
  contentClassName,
  constraints = baseConstraints,
  isOpen = true
}) => (
  <Modal
    isOpen={isOpen}
    className='modal-container'
    overlayClassName='modal'
    requestClose={onClose}
    style={{content: constraints}}>

    <button className='close' onClick={onClose} />
    <h1 className='title'>{title}</h1>
    <div className={contentClassName}>
      {children}
    </div>
  </Modal>
)

BaseModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  constraints: PropTypes.object,
  contentClassName: PropTypes.string
}

export default BaseModal



// WEBPACK FOOTER //
// ./src/components/base-modal.js